/**
 * DealPager — the top bar's "Deal 2 of 9 · New Lead" with ‹ › (deal detail
 * slice 1, §39.9; spec §3.1). Rendered by Dashboard into the shell's page-nav
 * slot; steps through the board's DISPLAY order carried with the open. No
 * order (opened from elsewhere) → nothing: no position is invented.
 * J / K do the same from the page itself (SalesDealDetail's listener).
 */
import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { DealStage } from '../../types'
import { dealPosition } from './dealNav'

export function DealPager({ dealId, order, stage, onNavigateDeal }: {
  dealId: string
  order: readonly string[] | null
  /** The open deal's stage, once read; null until then (no placeholder). */
  stage: DealStage | null
  onNavigateDeal: (id: string) => void
}) {
  // Slice 2 (by ruling): the pager steps over OPEN deals only. On a won or
  // lost deal it is shown but INERT — the stage, and both arrows disabled —
  // so the reader sees why there is nowhere to step.
  if (order && stage && (stage === 'Closed Won' || stage === 'Closed Lost')) {
    return (
      <div className="flex items-center gap-2 text-13 text-ink-secondary" data-deal-pager data-pager-inert>
        <span data-deal-position title="The pager steps through open deals only">{stage}</span>
        <button type="button" className="k-btn-secondary k-btn-secondary--flex" aria-label="Previous deal (K)" disabled>
          <ChevronLeft size={14} aria-hidden="true" />
        </button>
        <button type="button" className="k-btn-secondary k-btn-secondary--flex" aria-label="Next deal (J)" disabled>
          <ChevronRight size={14} aria-hidden="true" />
        </button>
      </div>
    )
  }
  const pos = dealPosition(order, dealId)
  if (!pos) return null
  return (
    <div className="flex items-center gap-2 text-13 text-ink-secondary" data-deal-pager>
      <span data-deal-position>Deal {pos.index} of {pos.total}{stage ? ` · ${stage}` : ''}</span>
      <button type="button" className="k-btn-secondary k-btn-secondary--flex" aria-label="Previous deal (K)"
        disabled={!pos.prevId} onClick={() => { if (pos.prevId) onNavigateDeal(pos.prevId) }}>
        <ChevronLeft size={14} aria-hidden="true" />
      </button>
      <button type="button" className="k-btn-secondary k-btn-secondary--flex" aria-label="Next deal (J)"
        disabled={!pos.nextId} onClick={() => { if (pos.nextId) onNavigateDeal(pos.nextId) }}>
        <ChevronRight size={14} aria-hidden="true" />
      </button>
    </div>
  )
}
